import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth/auth.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'ceb-front';
  username: string | undefined;
  roles: string[] = [];
  groups: string[] = [];

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    if (!this.authService.isInitialized()) {
      this.authService.init().then(() => {
        this.username = this.authService.getUsername();
        this.roles = this.authService.getRealmRoles();
        this.groups = this.authService.getGroupsFromToken();
        // Debug: log token info
        try {
          // tokenParsed may be undefined; guard
          const parsed = this.authService.getTokenParsed();
          //console.info('Keycloak token parsed after init:', parsed);
          const token = this.authService.getToken();
         /*  console.info('Keycloak raw token present:', !!token); */
        } catch (e) {
          //console.warn('Unable to log Keycloak token parsed info', e);
        }
      }).catch((error) => {
        console.error('Erreur lors de l\'initialisation de du SSO :', error);
      });
    } else {
      // Already initialized by APP_INITIALIZER
      this.username = this.authService.getUsername();
      this.roles = this.authService.getRealmRoles();
      this.groups = this.authService.getGroupsFromToken();
      try {
        const parsed = this.authService.getTokenParsed();
        //console.info('Keycloak token parsed (already initialized):', parsed);
        const token = this.authService.getToken();
       /*  console.info('Keycloak raw token present:', !!token); */
      } catch (e) {
        console.warn('Unable to log SSO token parsed info', e);
      }
    }
  }

  logout(): void {
    this.authService.logout();
  }
}
